import { DevicePermission } from 'console/device/device_ts';
import { VehicleTab } from './tab';
import { DefaultTabKey } from 'console/shared/content/tab/types';
import { isVehicleDevice } from 'console/shared/contexts/device/config/utils';
export const vehicle_tab_definition = {
    key: DefaultTabKey.vehicle_tab,
    title: 'Управление',
    iconclass: 'ui-icon-tab-state',
    should_appear: (device) => device?.has_access(DevicePermission.view_state) &&
        isVehicleDevice(device.device_type()),
    render: VehicleTab,
};
